import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   userOrders: null,
};

const usersApiSlice = createSlice({
   name: 'users',
   initialState,
   reducers: {
      getAlluserOrders: (state, action) => {
         state.userOrders = action.payload?.data;
      },
      clearGetAlluserOrders: (state) => {
         state.selectedState = null;
      },
   },
});

export const { getAlluserOrders, clearGetAlluserOrders } = usersApiSlice.actions;

export default usersApiSlice.reducer;
